// Mock data for GROW Guild Landing Page

export const guildInfo = {
  name: "GROW",
  game: "Grand Chase Classic",
  tagline: "Grow Together. Chase Stronger.",
  description: "GROW was founded on July 12, 2025 — just two days after the journey began.\n\nBuilt entirely from scratch by a Free-to-Play Guild Master, the guild stands on dedication, consistency, and long-term vision.\n\nWhat started as a fresh beginning quickly evolved into a structured and steadily growing competitive community.",
  discordLink: "https://discord.com/invite/vPbQQdjy2j",
  youtubeChannel: "GCGUIDE",
  youtubeLink: "https://www.youtube.com/@gcguide?si=2k6Z2017-VtPIMKm",
  facebookLink: "https://www.facebook.com/groups/grandchaseclassic",
  githubLink: "https://github.com/fadelm2"
};


export const guildFeatures = [
  {
    id: 1,
    title: "Active Community",
    description: "An active community that supports one another and grows together.",
    icon: "Users"
  },
  {
    id: 2,
    title: "Daily & Weekly Farming",
    description: "Structured farming and coordinated clears for maximum rewards",
    icon: "Swords"
  },
  {
    id: 3,
    title: "Build & Guide Sharing",
    description: "Sharing builds, strategies, and useful insights to help members improve.",
    icon: "BookOpen"
  },
  {
    id: 4,
    title: "Positive Environment",
    description: "Respectful Behaviour, mutual respect, and enjoying progress together.",
    icon: "Heart"
  }
];

export const joinRequirements = [
  {
    id: 1,
    title: "Active Player",
    description: "Play regularly and contribute to guild activities",
    icon: "Zap"
  },
  {
    id: 2,
    title: "Willing to Improve",
    description: "Have the motivation to keep improving and progressing together",
    icon: "TrendingUp"
  },
  {
    id: 3,
    title: "Join Discord",
    description: "Required to join Discord for coordination and communication",
    icon: "MessageCircle"
  },
  {
    id: 4,
    title: "Respectful Play",
    description: "Respect each other, help one another, and create a positive environment",
    icon: "Shield"
  }
];


export const topStrongerMembers = [
  {
    id: 1,
    rank: 1,
    name: "Ali Fahmi",
    title: "Guild Master",
    level: "770",
    totalAttack: "1.25M+ TA",
    specialty: "Vision, Leadership & Competitive",
    mainHero: "Sieghart / Dio"
  },
  {
    id: 2,
    rank: 2,
    name: "BBM",
    title: "PVP Specialist",
    level: "777",
    totalAttack: "1.20M+ TA",
    specialty: "High-Rank Arena Dominator",
    mainHero: "Lass / Jin"
  },
  {
    id: 3,
    rank: 3,
    name: "Mitsuha",
    title: "Top Contributor",
    level: "680",
    totalAttack: "1.05M+ TA",
    specialty: "High DPS Raid Clears",
    mainHero: "Arme / Ley"
  },
  {
    id: 4,
    rank: 4,
    name: "Usagi",
    title: "PVE Specialist",
    level: "620",
    totalAttack: "980K+ TA",
    specialty: "Raid Coordination & Tank",
    mainHero: "Ronan / Ryan"
  },
  {
    id: 5,
    rank: 5,
    name: "Axverads",
    title: "Creative & Tech Support",
    level: "350",
    totalAttack: "850K+ TA",
    specialty: "Web Dev & Tactical Support",
    mainHero: "Elesis / Uno"
  },
  {
    id: 6,
    rank: 6,
    name: "?",
    title: "Open Slot",
    level: "X",
    totalAttack: "Top Tier",
    specialty: "Are You The Next Strongest?",
    mainHero: "Grand Chase Fighter"
  }
];

export const coreMembers = [
  {
    id: 1,
    name: "Ali Fahmi",
    role: "Guild Master",
    level: "770",
    specialty: "Vision, Leadership & Competitive"
  },
  {
    id: 2,
    name: "Usagi",
    role: "Core Member",
    level: "620",
    specialty: "PVE Specialist  & Community Support"
  },
  {
    id: 5,
    name: "Axverads",
    role: "Creative & Technical Support",
    level: "350",
    specialty: "Web Development & Design"
  },
  {
    id: 6,
    name: "Mitsuha",
    role: "Core Member",
    level: "680",
    specialty: "Top Contributor"
  },
  {
    id: 7,
    name: "BBM",
    role: "Core Member",
    level: "777",
    specialty: "PVP Specialist"
  },
  {
    id: 8,
    name: "?",
    role: "X",
    level: "X",
    specialty: ""
  }
];

export const achievements = [
  {
    id: 1,
    title: "Top 7",
    description: "Daily Ranking - [ G-Point 23380 ]",
    date: "8 Februari 2026",
    icon: "Trophy"
  },
  {
    id: 3,
    title: "50+ Peak concurrent members",
    description: "Maintaining 50+ active members consistently",
    date: "Januari 2026",
    icon: "Users"
  }
];

export const galleryImages = [
  {
    id: 1,
    title: "Knights of Grand Chase",
    category: "Hero Showcase",
    description: "Pertarungan epik para kesatria Aernas mempertahankan kedamaian dunia.",
    src: "/gallery/gc-1.jpg"
  },
  {
    id: 2,
    title: "Epic Raid Battle",
    category: "Guild Raid",
    description: "Kerjasama koordinasi guild dalam menaklukkan bos dungeon berlevel tinggi.",
    src: "/gallery/gc-2.jpg"
  },
  {
    id: 3,
    title: "Continent of Aernas",
    category: "Adventure",
    description: "Jelajahi berbagai benua penuh misteri bersama anggota GROW.",
    src: "/gallery/gc-3.jpg"
  },
  {
    id: 4,
    title: "PvP Arena Clash",
    category: "PvP Combat",
    description: "Pertarungan kompetitif 3v3 intensif untuk membuktikan ketangguhan guild.",
    src: "/gallery/gc-4.jpg"
  },
  {
    id: 5,
    title: "Hero Roster & Job Awakening",
    category: "Character Build",
    description: "Kombinasi formasi hero dan build skill terbaik untuk mendominasi pertempuran.",
    src: "/gallery/gc-5.jpg"
  },
  {
    id: 6,
    title: "Special Coordi & Awakening",
    category: "Guild Collection",
    description: "Tampilan visual legendaris dan kekuatan penuh para jawara Grand Chase.",
    src: "/gallery/gc-6.jpg"
  }
];

